import { render, staticRenderFns } from "./SimulacaoFinalizarSucesso.vue?vue&type=template&id=c4fb46a6"
import script from "./SimulacaoFinalizarSucesso.vue?vue&type=script&lang=js"
export * from "./SimulacaoFinalizarSucesso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports